module.exports = __webpack_public_path__ + "static/media/17.jpg.c541c224.webp";